<template>
  <div>
   <page-header headerTitle="PukkiTravels" />
    <santa-spinner v-if="isWaiting"></santa-spinner>
    <b-modal
      id="login-result-modal"
      ok-only
      hide-header-close
      :title="loginModalTitle"
      :header-bg-variant="loginModalBg"
    >{{ loginModalDefault }}</b-modal>
    <b-modal
      id="travel-result-modal"
      ok-only
      hide-header-close
      centered
      title="Matkan tiedot"
      :header-bg-variant="travelModalBg"
    >
      <b-row>
        <b-col>Lähtöpaikka:</b-col>
        <b-col>{{ travelModalDeparture }}</b-col>
      </b-row>
      <b-row>
        <b-col>Määränpää:</b-col>
        <b-col>{{ travelModalDestination }}</b-col>
      </b-row>
      <b-row>
        <b-col>Kulkuneuvo:</b-col>
        <b-col>{{ travelModalTransportation }}</b-col>
      </b-row>
      <b-row>
        <b-col>Matka-aika:</b-col>
        <b-col>{{ travelModalDuration }}</b-col>
      </b-row>
      <b-row>
        <b-col>Varausnumero:</b-col>
        <b-col>{{ travelModalReservationNumber }}</b-col>
      </b-row>
    </b-modal>
    <b-container fluid v-if="!isLoggedIn">
      <b-form-group
        id="userNameGroup"
        label="Käyttäjätunnus"
        label-for="userNameInput"
      >
        <b-form-input id="userNameInput" v-model="userName" type="text" placeholder="käyttäjätunnus" />
      </b-form-group>
      <b-form-group
        id="passwordGroup"
        label="Salasana"
        label-for="passwordInput"
      >
        <b-form-input id="passwordInput" v-model="password" type="password" placeholder="salasana" />
      </b-form-group>
      <b-button :disabled="isLoginClicked" style="margin-top: 10px" block pill variant="success" @click="doLogin" class="fullWidth">Kirjaudu</b-button>
    </b-container>
    <b-container v-else-if="isLoggedIn" class="container mrgnbtm">
      <b-form-group
        id="departureGroup"
        label="Lähtöpaikka"
        label-for="departureSelect"
      >
        <b-form-select v-model="departureSelect" :options="places" class="form-control" />
      </b-form-group>
      <b-form-group
        id="destinationGroup"
        label="Määränpää"
        label-for="destinationSelect"
      >
        <b-form-select v-model="destinationSelect" :options="places" class="form-control" />
      </b-form-group>
      <b-form-group
        id="travelTypeGroup"
        label="Kulkuneuvo"
        label-for="traveTypeInput"
      >
        <b-form-select v-model="travelTypeSelect" :options="transportation" class="form-control" />
      </b-form-group>
      <b-button :disabled="isTravelButtonDisabled" style="margin-top: 10px" block pill variant="success" @click="doTravelReservation" class="fullWidth">Varaa matka</b-button>

    </b-container>
  </div>
</template>

<script>
import PageHeader from './PageHeader.vue'
import SantaSpinner from './SantaSpinner.vue'
import { LoginService } from '../services/login.service'
import { TravelService } from '../services/travel.service'

export default {
  name: "Dashboard",
  components: {
    PageHeader,
    SantaSpinner
  },
  data() {
    return {
      loginClicked: false,
      travelClicked: false,
      loggedIn: false,
      userName: "",
      password: "",
      departureSelect: "",
      destinationSelect: "",
      travelTypeSelect: "",
      travelDeparture: "",
      travelDestination: "",
      travelTransportation: "",
      travelDuration: "",
      travelNumber: "",
      correctTravel: false,
      waitingTime: 3500,
      places: [
        "Addis Abeba",
        "Ain-Galaka",
        "Atlanta",
        "Bahr El Ghasal",
        "Bank of England",
        "Billingsgate Market",
        "Boston",
        "British Museum",
        "Buckingham Palace",
        "Cairo",
        "Calgary",
        "Canary Islands",
        "Cape Guardafui",
        "Cape St. Marie",
        "Cape Verde",
        "Capetown",
        "Charing Cross",
        "Charleston",
        "Chelsea Bridge",
        "Chicago",
        "Congo",
        "Country Hall",
        "Dallas",
        "Daressalam",
        "Dar-Fur",
        "Denver",
        "Dragon Mountain",
        "Duluth",
        "Egypt",
        "El Paso",
        "Euston",
        "Gold Coast",
        "Goods Station",
        "Helena",
        "Houses of Parlament",
        "Houston",
        "Imperial War Museum",
        "Kandjama",
        "Kansas City",
        "King's Cross",
        "Lake Victoria",
        "Lambeth Bridge",
        "Lambeth Palace",
        "Las Vegas",
        "Little Rock",
        "London",
        "London Zoo",
        "Los Angeles",
        "Madame Tussaud's",
        "Marble Arch",
        "Miami",
        "Montreal",
        "Morocco",
        "Mozamique",
        "Nashville",
        "National Gallery",
        "National Theatre",
        "New Orleans",
        "New York",
        "Ocomba",
        "Oklahoma City",
        "Old Scotland Yard",
        "Omaha",
        "Phoenix",
        "Pittsburgh",
        "Portland",
        "Post Office Tower",
        "Queen Mary's Gardens",
        "Raleigh",
        "Royal Albert Hall",
        "Royal Festival Hall",
        "Sahara",
        "Saint Louis",
        "Salt Lake City",
        "San Francisco",
        "Santa Fe",
        "Sault St. Marie",
        "Seattle",
        "Sierra Leone",
        "Slave Coast",
        "Smithfield Market",
        "Southwark Cathedral",
        "St. Helena",
        "St. Pancras",
        "Suakin",
        "Tamatave",
        "Tangier",
        "The Temple",
        "The Tower",
        "Timbuktu",
        "Toronto",
        "Tower Bridge",
        "Tripoli",
        "Tunis",
        "University of London",
        "Vancouver",
        "Vauxhall Park",
        "Victoria Falls",
        "Victoria Station",
        "Washington",
        "Waterloo",
        "Wellington Arch",
        "Wellington Museum",
        "Westminister Bridge",
        "Westminister Cathedral",
        "Whalefish Bay",
        "Winnipeg"
      ],
      transportation: [
        "juna",
        "polkupyörä",
        "taksi",
        "pukki-express",
        "metro",
        "lentokone"
      ]
    }
  },
  computed: {
    isWaiting() {
      if (this.loginClicked || this.travelClicked) return true;
      return false;
    },
    isLoggedIn() {
      return this.loggedIn;
    },
    isLoginClicked() {
      return this.loginClicked;
    },
    isTravelButtonDisabled() {
      return this.travelClicked || this.loginClicked;
    },
    loginModalTitle() {
      return this.isLoggedIn ? "Tervetuloa" : "Tuntematon käyttäjä";
    },
    loginModalBg() {
      return this.isLoggedIn ? "success" : "danger";
    },
    loginModalDefault() {
      return this.isLoggedIn ? "Käyttäjä " + this.userName + " on nyt kirjautunut sisään." : "Väärä käyttäjätunnus ja/tai salasana!";
    },
    travelModalDeparture() {
      return this.travelDeparture;
    },
    travelModalDestination() {
      return this.travelDestination;
    },
    travelModalTransportation() {
      return this.travelTransportation;
    },
    travelModalDuration() {
      return this.travelDuration;
    },
    travelModalReservationNumber() {
      return this.travelNumber;
    },
    travelModalBg() {
      return this.correctTravel ? "success" : "info";
    }
  },
  methods: {
    doLogin() {
      this.loginClicked = true;
      window.setTimeout(this.checkLogin, this.waitingTime);
    },
    checkLogin() {
      const loginService = new LoginService();
      const loginData = {
        loginName: document.getElementById("userNameInput")?.value ?? "",
        password: document.getElementById("passwordInput")?.value ?? "",
      };
      loginService.checkLogin(loginData).then((response) => {
        console.log(response);
        this.loggedIn = response.success;
        this.loginClicked = false;
        this.$bvModal.show("login-result-modal");
      });
    },
    doTravelReservation() {
      if (this.departureSelect != this.destinationSelect) {
        this.travelClicked = true;
        window.setTimeout(this.checkTravel, this.waitingTime);
      }
    },
    checkTravel() {
      const travelService = new TravelService();
      const travelCheckData = {
        departure: this.departureSelect,
        destination: this.destinationSelect,
        transportation: this.travelTypeSelect
      }
      travelService.checkTravel(travelCheckData).then(response => {
        this.travelClicked = false;
        this.showReservedTravel(response);
      })
    },
    showReservedTravel(travels) {
      console.log(travels);
      this.travelDeparture = travels.departure;
      this.travelDestination = travels.destination;
      this.travelTransportation = travels.transportation;
      this.travelDuration = travels.duration;
      this.travelNumber = travels.travelId;
      this.correctTravel = travels.correct;
      this.$bvModal.show("travel-result-modal");
    },
    mounted () {
        // this.getAllUsers();
    }
  }
}
</script>